const shareBlocks = document.querySelectorAll('[data-job-share]');

const closeShareBlock = (block) => {
  const toggle = block.querySelector('[data-job-share-toggle]');

  block.classList.remove('is-open');
  if (toggle) toggle.setAttribute('aria-expanded', 'false');
};

const closeOtherShareBlocks = (currentBlock) => {
  shareBlocks.forEach((block) => {
    if (block !== currentBlock) closeShareBlock(block);
  });
};

const updateShareBlockAlignment = (block) => {
  const dropdown = block.querySelector('[data-job-share-dropdown]');
  const viewportWidth = document.documentElement.clientWidth || window.innerWidth;
  const viewportGap = 16;

  if (!dropdown) return;

  block.classList.remove('is-align-right');

  if (dropdown.getBoundingClientRect().right > viewportWidth - viewportGap) {
    block.classList.add('is-align-right');
  }
};

shareBlocks.forEach((block) => {
  const toggle = block.querySelector('[data-job-share-toggle]');
  const dropdown = block.querySelector('[data-job-share-dropdown]');

  if (!toggle || !dropdown) return;

  toggle.setAttribute('aria-expanded', 'false');

  toggle.addEventListener('click', () => {
    const isOpen = block.classList.contains('is-open');

    closeOtherShareBlocks(block);
    block.classList.toggle('is-open', !isOpen);
    toggle.setAttribute('aria-expanded', String(!isOpen));

    if (!isOpen) updateShareBlockAlignment(block);
  });

  dropdown.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    if (event.target.closest('.job-post-sec__share-item')) closeShareBlock(block);
  });
});

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Node)) return;

  shareBlocks.forEach((block) => {
    if (!block.contains(event.target)) closeShareBlock(block);
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  shareBlocks.forEach(closeShareBlock);
});

window.addEventListener('resize', () => {
  shareBlocks.forEach((block) => {
    if (block.classList.contains('is-open')) updateShareBlockAlignment(block);
  });
});
